// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-motion {
  --logo-duration: 6s;
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  isolation: isolate;
  background: #fff;
}

.logo-motion[data-theme="dark"] { background: #000; }
.logo-motion[data-theme="dark"] .logo-motion__shine { display: none; }
.logo-motion[data-theme="dark"] .logo-motion__control { color: #c1d3de; }
.logo-motion[data-theme="dark"] .logo-motion__control:hover { background: #0b2631; color: #80efff; }
.logo-motion[data-theme="dark"] .logo-motion__control:focus-visible { outline-color: #80efff; }

.logo-motion__fallback,
.logo-motion__art {
  display: block;
  width: 100%;
  height: 100%;
}

.logo-motion__art {
  position: absolute;
  inset: 0;
  overflow: hidden;
  visibility: hidden;
}

.logo-motion.is-ready .logo-motion__fallback { opacity: 0; }
.logo-motion.is-ready .logo-motion__art { visibility: visible; }
.logo-motion__orbit, .logo-motion__spark, .logo-motion__shine { opacity: 0; }

.logo-motion[data-state="playing"] .logo-motion__emblem {
  transform-origin: 50% 36%;
  animation: studio-emblem var(--logo-duration) both;
}

.logo-motion[data-state="playing"] .logo-motion__name {
  transform-origin: 50% 74%;
  animation: studio-name var(--logo-duration) both;
}

.logo-motion[data-state="playing"] .logo-motion__tagline {
  animation: studio-tagline var(--logo-duration) both;
}

.logo-motion[data-state="playing"] .logo-motion__orbit {
  animation: studio-orbit var(--logo-duration) both;
}

.logo-motion[data-state="playing"] .logo-motion__trail {
  stroke-dasharray: 1;
  animation: studio-trail var(--logo-duration) both;
}

.logo-motion[data-state="playing"] .logo-motion__spark {
  animation: studio-spark var(--logo-duration) both;
}

.logo-motion[data-state="playing"] .logo-motion__shine {
  animation: studio-shine var(--logo-duration) both;
}

.logo-motion[data-state="settling"] .logo-motion__art {
  animation: studio-settle 1s cubic-bezier(.2, .8, .2, 1) both;
}

.logo-motion.is-suspended * { animation-play-state: paused !important; }

.logo-motion__control {
  position: absolute;
  z-index: 2;
  right: 50%;
  bottom: -4rem;
  transform: translateX(50%);
  min-height: 2rem;
  padding: .35rem .65rem;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  color: #52616f;
  font: 500 .68rem/1.2 ui-sans-serif, system-ui, sans-serif;
  white-space: nowrap;
  cursor: pointer;
}

.logo-motion__control:hover { background: #f0fbff; color: #07566d; }
.logo-motion__control:focus-visible { outline: 2px solid #087f9c; outline-offset: 2px; }
.logo-motion__control[hidden] { display: none; }

@keyframes studio-emblem {
  0%, 5% { opacity: 0; transform: translateY(36px) scale(.88) rotate(-7deg); filter: blur(7px); }
  27% { opacity: 1; transform: translateY(0) scale(1) rotate(0); filter: blur(0); animation-timing-function: ease-out; }
  68% { opacity: 1; transform: translateY(0) scale(1) rotate(0); filter: blur(0); animation-timing-function: cubic-bezier(.6, 0, .8, .4); }
  91%, 100% { opacity: 0; transform: translateY(-34px) scale(1.07) rotate(3deg); filter: blur(9px); }
}

@keyframes studio-name {
  0%, 16% { opacity: 0; transform: translateY(42px); filter: blur(5px); }
  34%, 68% { opacity: 1; transform: translateY(0); filter: blur(0); }
  85%, 100% { opacity: 0; transform: translateY(-25px); filter: blur(6px); }
}

@keyframes studio-tagline {
  0%, 25% { opacity: 0; transform: translateY(23px); }
  42%, 66% { opacity: 1; transform: translateY(0); }
  79%, 100% { opacity: 0; transform: translateY(-16px); }
}

@keyframes studio-orbit {
  0%, 2% { opacity: 0; }
  7%, 20% { opacity: 1; }
  32%, 67% { opacity: 0; }
  72%, 83% { opacity: 1; }
  94%, 100% { opacity: 0; }
}

@keyframes studio-trail {
  0%, 3% { stroke-dashoffset: 1; }
  24% { stroke-dashoffset: 0; }
  34%, 66% { stroke-dashoffset: -1; }
  67% { stroke-dashoffset: 1; }
  86% { stroke-dashoffset: 0; }
  96%, 100% { stroke-dashoffset: -1; }
}

@keyframes studio-spark {
  0%, 22% { opacity: 0; }
  26% { opacity: .95; }
  34%, 68% { opacity: 0; }
  73% { opacity: .8; }
  82%, 100% { opacity: 0; }
}

@keyframes studio-shine {
  0%, 33% { opacity: 0; translate: 0; }
  36% { opacity: .65; }
  57% { opacity: 0; translate: 2000px; }
  100% { opacity: 0; translate: 2000px; }
}

@keyframes studio-settle {
  from { opacity: 0; transform: translateY(8px) scale(.98); }
  to { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce) {
  .logo-motion .logo-motion__art,
  .logo-motion .logo-motion__art * { animation: none !important; }
  .logo-motion__control { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/logo-motion.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kCAAkC,gBAAgB,EAAE;AACpD,sDAAsD,aAAa,EAAE;AACrE,wDAAwD,cAAc,EAAE;AACxE,8DAA8D,mBAAmB,EAAE,cAAc,EAAE;AACnG,sEAAsE,sBAAsB,EAAE;;AAE9F;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+CAA+C,UAAU,EAAE;AAC3D,0CAA0C,mBAAmB,EAAE;AAC/D,gEAAgE,UAAU,EAAE;;AAE5E;EACE,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA,8BAA8B,uCAAuC,EAAE;;AAEvE;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,yDAAyD;EACzD,mBAAmB;EACnB,eAAe;AACjB;;AAEA,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,sCAAsC,0BAA0B,EAAE,mBAAmB,EAAE;AACvF,gCAAgC,aAAa,EAAE;;AAE/C;EACE,SAAS,UAAU,EAAE,oDAAoD,EAAE,iBAAiB,EAAE;EAC9F,MAAM,UAAU,EAAE,2CAA2C,EAAE,eAAe,EAAE,mCAAmC,EAAE;EACrH,MAAM,UAAU,EAAE,2CAA2C,EAAE,eAAe,EAAE,sDAAsD,EAAE;EACxI,YAAY,UAAU,EAAE,qDAAqD,EAAE,iBAAiB,EAAE;AACpG;;AAEA;EACE,UAAU,UAAU,EAAE,2BAA2B,EAAE,iBAAiB,EAAE;EACtE,WAAW,UAAU,EAAE,wBAAwB,EAAE,eAAe,EAAE;EAClE,YAAY,UAAU,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AAC3E;;AAEA;EACE,UAAU,UAAU,EAAE,2BAA2B,EAAE;EACnD,WAAW,UAAU,EAAE,wBAAwB,EAAE;EACjD,YAAY,UAAU,EAAE,4BAA4B,EAAE;AACxD;;AAEA;EACE,SAAS,UAAU,EAAE;EACrB,UAAU,UAAU,EAAE;EACtB,WAAW,UAAU,EAAE;EACvB,WAAW,UAAU,EAAE;EACvB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,SAAS,oBAAoB,EAAE;EAC/B,MAAM,oBAAoB,EAAE;EAC5B,WAAW,qBAAqB,EAAE;EAClC,MAAM,oBAAoB,EAAE;EAC5B,MAAM,oBAAoB,EAAE;EAC5B,YAAY,qBAAqB,EAAE;AACrC;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,MAAM,YAAY,EAAE;EACpB,WAAW,UAAU,EAAE;EACvB,MAAM,WAAW,EAAE;EACnB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,UAAU,UAAU,EAAE,YAAY,EAAE;EACpC,MAAM,YAAY,EAAE;EACpB,MAAM,UAAU,EAAE,iBAAiB,EAAE;EACrC,OAAO,UAAU,EAAE,iBAAiB,EAAE;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE,qCAAqC,EAAE;EAC1D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE;qCACmC,0BAA0B,EAAE;EAC/D,wBAAwB,aAAa,EAAE;AACzC","sourcesContent":[".logo-motion {\n  --logo-duration: 6s;\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1;\n  isolation: isolate;\n  background: #fff;\n}\n\n.logo-motion[data-theme=\"dark\"] { background: #000; }\n.logo-motion[data-theme=\"dark\"] .logo-motion__shine { display: none; }\n.logo-motion[data-theme=\"dark\"] .logo-motion__control { color: #c1d3de; }\n.logo-motion[data-theme=\"dark\"] .logo-motion__control:hover { background: #0b2631; color: #80efff; }\n.logo-motion[data-theme=\"dark\"] .logo-motion__control:focus-visible { outline-color: #80efff; }\n\n.logo-motion__fallback,\n.logo-motion__art {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.logo-motion__art {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.logo-motion.is-ready .logo-motion__fallback { opacity: 0; }\n.logo-motion.is-ready .logo-motion__art { visibility: visible; }\n.logo-motion__orbit, .logo-motion__spark, .logo-motion__shine { opacity: 0; }\n\n.logo-motion[data-state=\"playing\"] .logo-motion__emblem {\n  transform-origin: 50% 36%;\n  animation: studio-emblem var(--logo-duration) both;\n}\n\n.logo-motion[data-state=\"playing\"] .logo-motion__name {\n  transform-origin: 50% 74%;\n  animation: studio-name var(--logo-duration) both;\n}\n\n.logo-motion[data-state=\"playing\"] .logo-motion__tagline {\n  animation: studio-tagline var(--logo-duration) both;\n}\n\n.logo-motion[data-state=\"playing\"] .logo-motion__orbit {\n  animation: studio-orbit var(--logo-duration) both;\n}\n\n.logo-motion[data-state=\"playing\"] .logo-motion__trail {\n  stroke-dasharray: 1;\n  animation: studio-trail var(--logo-duration) both;\n}\n\n.logo-motion[data-state=\"playing\"] .logo-motion__spark {\n  animation: studio-spark var(--logo-duration) both;\n}\n\n.logo-motion[data-state=\"playing\"] .logo-motion__shine {\n  animation: studio-shine var(--logo-duration) both;\n}\n\n.logo-motion[data-state=\"settling\"] .logo-motion__art {\n  animation: studio-settle 1s cubic-bezier(.2, .8, .2, 1) both;\n}\n\n.logo-motion.is-suspended * { animation-play-state: paused !important; }\n\n.logo-motion__control {\n  position: absolute;\n  z-index: 2;\n  right: 50%;\n  bottom: -4rem;\n  transform: translateX(50%);\n  min-height: 2rem;\n  padding: .35rem .65rem;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  background: transparent;\n  color: #52616f;\n  font: 500 .68rem/1.2 ui-sans-serif, system-ui, sans-serif;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.logo-motion__control:hover { background: #f0fbff; color: #07566d; }\n.logo-motion__control:focus-visible { outline: 2px solid #087f9c; outline-offset: 2px; }\n.logo-motion__control[hidden] { display: none; }\n\n@keyframes studio-emblem {\n  0%, 5% { opacity: 0; transform: translateY(36px) scale(.88) rotate(-7deg); filter: blur(7px); }\n  27% { opacity: 1; transform: translateY(0) scale(1) rotate(0); filter: blur(0); animation-timing-function: ease-out; }\n  68% { opacity: 1; transform: translateY(0) scale(1) rotate(0); filter: blur(0); animation-timing-function: cubic-bezier(.6, 0, .8, .4); }\n  91%, 100% { opacity: 0; transform: translateY(-34px) scale(1.07) rotate(3deg); filter: blur(9px); }\n}\n\n@keyframes studio-name {\n  0%, 16% { opacity: 0; transform: translateY(42px); filter: blur(5px); }\n  34%, 68% { opacity: 1; transform: translateY(0); filter: blur(0); }\n  85%, 100% { opacity: 0; transform: translateY(-25px); filter: blur(6px); }\n}\n\n@keyframes studio-tagline {\n  0%, 25% { opacity: 0; transform: translateY(23px); }\n  42%, 66% { opacity: 1; transform: translateY(0); }\n  79%, 100% { opacity: 0; transform: translateY(-16px); }\n}\n\n@keyframes studio-orbit {\n  0%, 2% { opacity: 0; }\n  7%, 20% { opacity: 1; }\n  32%, 67% { opacity: 0; }\n  72%, 83% { opacity: 1; }\n  94%, 100% { opacity: 0; }\n}\n\n@keyframes studio-trail {\n  0%, 3% { stroke-dashoffset: 1; }\n  24% { stroke-dashoffset: 0; }\n  34%, 66% { stroke-dashoffset: -1; }\n  67% { stroke-dashoffset: 1; }\n  86% { stroke-dashoffset: 0; }\n  96%, 100% { stroke-dashoffset: -1; }\n}\n\n@keyframes studio-spark {\n  0%, 22% { opacity: 0; }\n  26% { opacity: .95; }\n  34%, 68% { opacity: 0; }\n  73% { opacity: .8; }\n  82%, 100% { opacity: 0; }\n}\n\n@keyframes studio-shine {\n  0%, 33% { opacity: 0; translate: 0; }\n  36% { opacity: .65; }\n  57% { opacity: 0; translate: 2000px; }\n  100% { opacity: 0; translate: 2000px; }\n}\n\n@keyframes studio-settle {\n  from { opacity: 0; transform: translateY(8px) scale(.98); }\n  to { opacity: 1; transform: none; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .logo-motion .logo-motion__art,\n  .logo-motion .logo-motion__art * { animation: none !important; }\n  .logo-motion__control { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
